/* ============
 * All Product Types
 * ============
 *
 * All product types.
 */

import Vue from 'vue';
import store from './../../store';
import productSubtypeTransformer from './../../transformers/productSubtype';

const success = ({ data }, resolve) => {
  const productSubtypes = productSubtypeTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllProductSubtypes', productSubtypes);
  resolve();
};

const failed = (error, reject) => reject(error);

// Display product types.
export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('product_subtypes')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productSubtype/all.js